import React from 'react'
import PropTypes from 'prop-types'

import NextLevelBar from '../NextLevelBar'

function ReputationLevelTooltip({ reputation, nextLevel }) {
  return (
    <div className="reputation-level-tooltip">
      <div className="tooltip-title">Till next level:</div>
      <NextLevelBar currentRep={reputation} nextRep={nextLevel} />
      <a href="/levels" target="_blank" className="tooltip-link">Learn more</a>
    </div>
  )
}

ReputationLevelTooltip.propTypes = {
  reputation: PropTypes.number.isRequired,
  nextLevel: PropTypes.number.isRequired,
}

export default ReputationLevelTooltip
